import { createRecipe } from './runtime';

const codeConfig = {"name":"code","defaultVariants":{"size":"md","variant":"outline"},"variantMap":{"size":["lg","md","sm"],"variant":["ghost","outline"]}}

export const code = /* @__PURE__ */ createRecipe(codeConfig)